import React, {useState, useEffect, useContext} from 'react'
import {useHistory} from 'react-router-dom'
import farmerContext from '../../../context/farmer/farmerContext'
import {useAlert} from "react-alert";


const AddFarmForm = (props) => {
    const alert = useAlert()
    const FarmerContext = useContext(farmerContext);

    const {getFarmType, getStates, getLga, addFarm, clearAlert, farmer} = FarmerContext;
    const {farmLgas, farmStates, farmTypes} = farmer;

    let history = useHistory();

    //Initialize states for the input values
    const [state_id, setstate_id] = useState(0);
    const [longitude, setLongitude] = useState('');
    const [latitude, setLatitude] = useState('');
    const [user_data, setUser_data] = useState({
        //button loader for submit
        hide_spinner: "d-none",
        disable_button: false,

    })

    useEffect(() => {
        //Get users location when the component mounts
        getLocation();

        if (farmTypes.length === 0) {
            getFarmType();
        }
        if (farmStates.length === 0) {
            getStates();
        }
        if (farmer.message.msg !== "") {
            alert.show(
                farmer.message.msg, farmer.message.msg_options
            )
            clearAlert()
        }

    }, [farmStates, state_id, farmer.message.msg]);
    // getLga(state_id);


    //Get Users location
    const getLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition);
        } else {
            // alert( "Geolocation is not supported by this browser.");
        }
    }

    //Set the longitude and latitude
    const showPosition = position => {

        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;

        setLatitude(latitude);
        setLongitude(longitude);

    }

    const onSubmit = e => {
        e.preventDefault()

        //button loader for submit
        setUser_data(prevState => ({
                ...prevState,
                disable_button: true,
                hide_spinner: " d-inline-block"
            })
        )

        let add_farm_form = document.getElementById("add_farm_form");

        let new_farm = new FormData(add_farm_form);
        addFarm(new_farm).then(res => {
            if (res.data.error === false) {
                setUser_data(prevState => ({
                        ...prevState,
                        disable_button: false,
                        hide_spinner: " d-none"
                    })
                )
                add_farm_form.reset();
                history.push('/farmer/farm/manage');
            }
        })
    }

    return (

        <div className="content-wrapper">
            <div className="container-fluid">
                <div className="dashboard-inner-view">
                    <div className="row mt-3 justify-content-center">
                        <div className="profile-info-details">
                            <div className="col-lg-12">
                                <div className="row">
                                    <div className="col-lg-12">

                                        <h3 className="make-bold">Add Farm</h3>
                                        <p>Add your farm</p>
                                    </div>


                                    <div className="col-lg-12 card">
                                        <div className="card-body">
                                            <form onSubmit={onSubmit} id="add_farm_form">

                                                <div className="form-group mb-5">
                                                    <label>Farm Name</label>
                                                    <input type="text" className="form-control form-control-custom-view"
                                                           name='farm_name' placeholder="Ajayi Farms" required/>
                                                </div>

                                                <div className="form-group mb-5">
                                                    <label>Farm Type</label>

                                                    <select className="form-control " name="farm_type_id"
                                                            id="farm_type_id">
                                                        <option>--Select farm type--</option>
                                                        {farmTypes.length > 0 ?
                                                            farmTypes.map(farmType => (
                                                                <option value={farmType.id}
                                                                        key={farmType.id}>{farmType.name}
                                                                </option>
                                                            ))

                                                            : <option>--Select farm type--</option>

                                                        }
                                                    </select>

                                                </div>

                                                <div className="form-group mb-5">
                                                    <label>Farm State</label>
                                                    <select className="form-control " name="state_id" id="state_id"
                                                            onChange={e => getLga(e.target.value)}
                                                    >
                                                        <option>--Select state--</option>

                                                        {farmStates.length > 0 ?
                                                            farmStates.map(farmState => (
                                                                <option value={farmState.id}
                                                                        key={farmState.id}>{farmState.name}
                                                                </option>
                                                            ))

                                                            : <option>--Select state--</option>

                                                        }
                                                    </select>
                                                </div>

                                                <div className="form-group mb-5">
                                                    <label>Farm LGA</label>
                                                    <select className="form-control " name="lga_id" id="lga_id">
                                                        <option>--Select Lga--</option>
                                                        {farmLgas.length > 0 ?
                                                            farmLgas.map(farmLga => (
                                                                <option value={farmLga.id}
                                                                        key={farmLga.id}>{farmLga.name}
                                                                </option>
                                                            ))

                                                            : <option>--Select Lga--</option>

                                                        }
                                                    </select>
                                                </div>

                                                <div className="form-group mb-5">
                                                    <label>Farm Size</label>
                                                    <input type="number" min="1"
                                                           className="form-control form-control-custom-view"
                                                           name='farm_size' placeholder="size in hectares" required/>
                                                </div>


                                                <div className="form-group">

                                                    <input type="hidden" name="city_id" value="3"/>
                                                </div>
                                                <div className="form-group">

                                                    <input type="hidden" name="latitude" value={latitude && latitude}/>
                                                </div>
                                                <div className="form-group">
                                                    <input type="hidden" name="longitude"
                                                           value={longitude && longitude}/>
                                                </div>

                                                <div className="form-group mb-5">
                                                    <label>Address</label>
                                                    <textarea className="form-control form-control-custom-view" rows="5"
                                                              name='address'
                                                              placeholder="No 3, Hebert Perkins Street, Lekki"
                                                              required>

                                    </textarea>
                                                </div>

                                                <div className="form-row justify-content-center mb-5">

                                                    <button type="submit"
                                                            className="btn btn-orange btn-custom-view
                                                                text-white d-flex justify-content-center align-items-center"
                                                            disabled={user_data.disable_button}>
                                                        Add Farm
                                                        <i className="ml-1 fa fa-check" aria-hidden="true"> </i>
                                                        <span
                                                            className={"spinner-border spinner-border-sm ml-2 " + user_data.hide_spinner}
                                                            role="status"
                                                            aria-hidden="true">
                                                        </span>
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!--End Dashboard Content--> */}
            </div>
            {/* <!-- End container-fluid--> */}
        </div>
        // {/* <!--End content-wrapper--> */}

    )
}

export default AddFarmForm
